import Typography from '@dynatrace/strato-design-tokens/typography';

import { getTokenComputedStyle } from './getTokenComputedStyle.js';

/**
 * Returns the context font details.
 * @internal
 * @param fontWeight -
 * @param fontSize - font size to add to the context font.
 * @param lineHeight -
 */
export const getFontDetails = (
  fontWeight: number,
  fontSize: number,
  lineHeight: number,
) => {
  const stringFontSize = `${fontSize}px/${lineHeight}`;

  return [
    fontWeight,
    stringFontSize,
    getTokenComputedStyle(Typography.Text.Small.Emphasized.Family),
  ].join(' ');
};
